// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'


import App from './App'
import router from './router'
import Element from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
Vue.use(mavonEditor)
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)



// if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
//   Vue.prototype.$pc = false
// } else {
Vue.prototype.$pc = true
let winWidth = document.documentElement.offsetWidth ||
  document.body.offsetWidth
winWidth = winWidth < 1366 ? 1366 : winWidth
let oHtml = document.getElementsByTagName('html')[0]
oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'
window.addEventListener('resize', function () {
  let winWidth = document.documentElement.offsetWidth || document.body.offsetWidth
  winWidth = winWidth < 1366 ? 1366 : winWidth
  let oHtml = document.getElementsByTagName('html')[0]
  oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'
})
// }



Vue.use(Element);
Vue.config.productionTip = false
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})
router.afterEach(() => {
  window.scrollTo(0, 0);
  NProgress.done()
})
/* eslint-disable no-new */
import store from './store'
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js